/**
 * Returns a locale-aware ordinal string for a given number.
 * e.g. toOrdinal(2, 'fr') → '2ème', toOrdinal(2, 'en') → '2nd'
 */
export function toOrdinal(n: number, lng: string = 'fr'): string {
  if (lng.startsWith('fr')) {
    if (n === 1) return '1er';
    return `${n}ème`;
  }

  // English ordinals
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  const suffix = suffixes[(v - 20) % 10] ?? suffixes[v] ?? suffixes[0];
  return `${n}${suffix}`;
}
